import axios from 'axios';
import { getToken } from './tokenStore';
import { maybeConfirmCloakedWrite, shouldEverGate } from './cloakWriteGuard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// attach Bearer if a token is in memory (back-up to the HttpOnly cookie
// set by the backend on sign-in; primary auth is the cookie, this is
// only a fallback for back-compat with any caller that explicitly reads
// from getToken()).
api.interceptors.request.use(async (config) => {
  const tok = getToken();
  if (tok) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${tok}`;
  }
  // Role impersonation — only honoured by the backend when the real caller is
  // a system_admin (see auth_utils.get_current_user). Sending it as a
  // non-admin is silently ignored. Skip the /auth/impersonate endpoint itself
  // so the audit record always reflects the real role.
  const impersonate = localStorage.getItem('ve_impersonate_role');
  if (impersonate && !(config.url || '').includes('/auth/impersonate')) {
    config.headers = config.headers || {};
    config.headers['X-Impersonate-Role'] = impersonate;

    // v157 — Maker safety: gate cross-role writes behind a confirm
    // modal. Risky endpoints (approvals, money, role mutations,
    // deletes, admin) ALWAYS confirm. Benign writes follow a
    // session-scoped opt-in. See lib/cloakWriteGuard.js + AppRouter's
    // <CloakWriteConfirmModal />.
    if (shouldEverGate(config.method, config.url)) {
      const ok = await maybeConfirmCloakedWrite({
        method: config.method,
        url: config.url,
        cloakedAs: impersonate,
      });
      if (!ok) {
        throw new axios.Cancel('cloak-write-cancelled-by-maker');
      }
    }
  }
  return config;
});

export default api;
